/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownLeftIcon24Solid = forwardRef('ArrowShapeADownLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.875 20.751a2.625 2.625 0 0 1-2.625-2.625V5.313c0-1.337 1.616-2.006 2.56-1.061l2.97 2.97 4.254-4.253a2.25 2.25 0 0 1 3.182 0l4.815 4.816a2.25 2.25 0 0 1 0 3.182l-4.252 4.252 2.971 2.971c.945.945.276 2.56-1.06 2.56l-12.815.001Z" })));
});
